import { Button, rem } from '@innovyze/stylovyze';
import { Check, Close, Delete, Edit, MoreVert } from '@mui/icons-material';
import {
	Grid,
	Switch,
	Table,
	TableCell,
	TableHead,
	TableRow,
	Typography,
} from '@mui/material';
import styled, { css } from 'styled-components';

export const EntitlementSwitch = styled(Switch)`
	.MuiSwitch-switchBase {
		color: #a5bdc6;
		padding: 9px !important;
		&.Mui-checked {
			color: #00abd1;
			padding: 9px !important;
			position: absolute !important;
		}
		&.MuiSwitch-colorSecondary {
			position: absolute !important;
		}
		&.Mui-checked + .MuiSwitch-track {
			background-color: #a5bdc6;
		}
	}
`;

export const Title = styled(Typography)`
	font-style: normal;
	font-weight: 400;
	font-size: 18px;
	line-height: 32px;
	text-align: left;
	color: #272833;
`;

export const actionStyles = css`
	color: #768d95;
	margin: 0px 10px;
	cursor: pointer;
`;
export const StyledMoreVert = styled(MoreVert)`
	${actionStyles}
`;

export const StyledEdit = styled(Edit)`
	${actionStyles}
`;

export const StyledDelete = styled(Delete)`
	${actionStyles}
`;

export const HeaderCell = styled(TableCell)`
	color: #4a6067;
	width: '22%';
`;

export const StyledGrid = styled(Grid)`
	padding: 37px;
`;

export const StyledButton = styled(Button)`
	&& {
		color: #ffffff;
		background-color: #007ca0;
		float: right;
	}
`;

export const StyledTable = styled(Table)`
	table-layout: 'auto';
`;

export const TableHeader = styled(TableHead)`
	background: #f2f2f2;
`;

export const TableBodyCell = styled(TableCell)`
	width: 22%;
`;

export const TableActionCell = styled(TableCell)`
	width: 12%;
	text-align: right;
`;

export const StyledCheck = styled(Check)`
	color: #528c05;
	margin: 0px 10px;
`;

export const StyledClose = styled(Close)`
	color: #ae3c1b;
	margin: 0px 10px;
`;

export const TableRowSelected = styled(TableRow)`
	border: ${({ selected }) => (selected ? '2px solid #60DDFF' : '')};
`;

export const StyledModal = styled('div')`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	outline: none;
`;

export const EntitlementsTableHeaderWrapper = styled.div`
	display: grid;
	grid-template-columns: ${rem(421)} auto auto;
	grid-gap: ${rem(16)};
`;
